import React from 'react'
import PropTypes from 'prop-types'
import { InWinImage } from 'routes/shared/components'

import * as styles from './styles'

export const FlagCellComponent = ({ value }) => (
  <InWinImage source={value} alt={value} css={styles.flag} />
)

FlagCellComponent.propTypes = {
  value: PropTypes.string,
}
